package com.essntl.uikit.components.toaster

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.icons.EsLargeIcon
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.EsColorScheme
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun EsToaster(
    state: EsToasterState = EsToasterState.Information,
    title: String,
    description: String? = null,
    dismissible: Boolean = false,
    onDismiss: (() -> Unit)? = null,
    modifier: Modifier = Modifier,
) {
    val colors = getToasterColors(MaterialTheme.esColorScheme)

    Box(
        modifier = modifier
            .border(
                width = 1.dp,
                color = when (state) {
                    EsToasterState.Success -> colors.borderSuccessColor
                    EsToasterState.Warning -> colors.borderWarningColor
                    EsToasterState.Error -> colors.borderErrorColor
                    EsToasterState.Information -> colors.borderInformationColor
                },
                shape = RoundedCornerShape(size = 16.dp),
            )
            .clip(RoundedCornerShape(size = 16.dp))
            .background(MaterialTheme.esColorScheme.bgSecondary)
            .width(356.dp)
            .heightIn(min = 48.dp)
            .padding(
                top = 1.spacing,
                bottom = 1.5.spacing,
                start = 2.spacing,
                end = if (dismissible) 1.spacing else 2.spacing,
            ),
    ) {
        Row(
            modifier = Modifier.padding(top = .5.spacing).align(Alignment.TopStart),
            horizontalArrangement = Arrangement.spacedBy(1.5.spacing),
        ) {
            EsLargeIcon(
                res = when (state) {
                    EsToasterState.Success -> EsIcons.CheckCircle
                    else -> EsIcons.InfoCircle
                },
                tint = when (state) {
                    EsToasterState.Success -> colors.iconSuccessColor
                    EsToasterState.Warning -> colors.iconWarningColor
                    EsToasterState.Error -> colors.iconErrorColor
                    EsToasterState.Information -> colors.iconInformationColor
                },
            )
            Column(
                verticalArrangement = Arrangement.Top,
                horizontalAlignment = Alignment.Start,
            ) {
                Text(
                    text = title,
                    style = MaterialTheme.esTypography.s1Bold16,
                    color = MaterialTheme.esColorScheme.textPrimary,
                )
                if (!description.isNullOrEmpty())
                    Text(
                        text = description,
                        style = MaterialTheme.esTypography.p1Regular16,
                        color = MaterialTheme.esColorScheme.textPrimary,
                    )
            }
        }

        if (dismissible)
            EsLargeIcon(
                res = EsIcons.Close,
                tint = MaterialTheme.esColorScheme.iconPrimary,
                modifier = Modifier
                    .clip(CircleShape)
                    .clickable {
                        onDismiss?.invoke()
                    }
                    .align(Alignment.TopEnd)
            )
    }

}


class EsToasterColors(
    val borderInformationColor: Color,
    val borderWarningColor: Color,
    val borderErrorColor: Color,
    val borderSuccessColor: Color,
    val iconInformationColor: Color,
    val iconWarningColor: Color,
    val iconErrorColor: Color,
    val iconSuccessColor: Color,
)

enum class EsToasterState {
    Information,
    Success,
    Warning,
    Error,
}

fun getToasterColors(esColorScheme: EsColorScheme) = EsToasterColors(

    //Border
    borderInformationColor = esColorScheme.borderAccent,
    borderWarningColor = esColorScheme.borderWarning,
    borderErrorColor = esColorScheme.borderError,
    borderSuccessColor = esColorScheme.borderSuccess,

    //Icon
    iconInformationColor = esColorScheme.iconPrimary,
    iconWarningColor = esColorScheme.iconWarning,
    iconErrorColor = esColorScheme.iconError,
    iconSuccessColor = esColorScheme.iconSuccess,
)